import api from '../../api/UserActivities/index'

const defaultState = () => {
  return {
    currentAuthorizedActivities: [],
    currentActivity: null,
    currentActivityKey: null,
    currentPersonId: null,
    currentRoleName: null,
    currentActiveState: null,
    currentUser: null,
  }
}

const actions = {
  getAuthorizedActivities({ commit, rootState }) {
    const { currentActivityKey, currentPersonId } = rootState.context

    return api
      .getUserActivities({ key: currentActivityKey, id: currentPersonId })
      .then(res => {
        commit('setAuthorizedActivities', res)
      })
      .catch(error =>
        commit('toast/setToastMessage', `An error occurred: ${error}`, {
          root: true,
        }),
      )
  },
}

const getters = {
  getActivityKey(state) {
    return state.currentActivity || state.currentActivityKey
  },
  getUser(state) {
    return state.currentActivity
      ? state.currentActivity.users.find(
          user => user.personId === state.currentPersonId,
        )
      : null
  },
  getRoleName(state, getters) {
    const user = getters.getUser(state)
    return user ? user.role.roleName : ''
  },
  getActiveState(state, getters) {
    const user = getters.getUser(state)
    return user ? user.activeState : 0
  },
}

const mutations = {
  setContextKey(state, payload) {
    const { currentActivityKey, currentPersonId } = payload
    state.currentPersonId = currentPersonId
    state.currentActivityKey = currentActivityKey
  },
  setContext(state, payload) {
    const {
      currentActiveState,
      currentActivity,
      currentActivityKey,
      currentPersonId,
      currentRoleName,
    } = payload.context

    if (currentActivity) {
      state.currentActivity = currentActivity
      state.currentPersonId = currentPersonId
      state.currentActivityKey = state.currentActivity.key
    }

    if (!currentActivity) {
      state.currentActivityKey = currentActivityKey
      state.currentPersonId = currentPersonId
      state.currentRoleName = currentRoleName
      state.currentActiveState = currentActiveState
    } else if (
      currentActivity &&
      state.currentActivityKey != state.currentActivity.key
    ) {
      state.currentActivityKey = currentActivity.key
      state.currentPersonId = currentPersonId
      state.currentRoleName = currentRoleName
      state.currentActiveState = currentActiveState
    }
  },
  setAuthorizedActivities(state, payload) {
    state.currentAuthorizedActivities = payload.data.authorizedActivities
  },
  setLogedInUser(state, user) {
    state.currentUser = user
  },
  resetState: state => {
    Object.assign(state, defaultState())
  },
}

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  getters,
  mutations,
}
